function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.994 1.506a7.505 7.505 0 00-7.133 9.823l-5.397 5.397a.75.75 0 00-.22.53v3.75a.75.75 0 00.75.75h3.75a.75.75 0 00.75-.75v-1.5h1.5a.75.75 0 00.75-.75v-1.5h1.5a.75.75 0 00.53-.22l.898-.897a7.502 7.502 0 102.322-14.633zM16.87 8.63a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: props.fill
  }));
}

export default SvgKey;